import { Molecule, Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import { LogoSvg } from 'components/icons';
import { Button, HoverEffect } from './atoms';
import { GenericWrapper } from 'wrappers';

const template = styled.div`
  ${({ theme }) => css`
    position: relative;
    border-radius: 60px;
    overflow: hidden;
    color: red;
    cursor: pointer;
    border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
    font-size: 14px;
    background-color: ${theme?.colour?.primary ?? "#1DBD6B"};
    font-weight: 400;

    svg {
      display: none;
    }

    &:hover {
      svg {
        display: unset;
      }
      background: white;
    }

    // @media only screen and (min-width: 768px) {
    //   font-weight: 600;
    //   font-size: 14px;
    // }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: GenericWrapper,
      name: 'Wrapper',
      atoms: [
        {
          component: HoverEffect,
          name: 'HoverEffect',
          displayValue: () => LogoSvg({})
        },
        {
          component: Button,
          name: 'Button',
          displayValue: ({ title }) => title,
          displayState: ({ big, disabled }) => ({ big, disabled }),
        },
      ]
    }
  ]
})
